module.exports = __webpack_public_path__ + "media/svg/tr-69a0293b.svg";